module.exports = __webpack_public_path__ + "img/ROI.ee3ff251.svg";